import React from 'react';
import {
  Form, Input, Button, Upload, message, Row, Col, Breadcrumb, Grid
} from 'antd';
import { UploadOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { getCategories } from '../../common/services';
import './css/categorie.css';

const AjoutCategorie = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint(); // pour le bouton block sur mobile

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append('name', values.name);

      if (values.image && values.image.length) {
        formData.append('image', values.image[0].originFileObj);
      }

      await getCategories.post(formData);
      message.success('Catégorie ajoutée avec succès');
      navigate('/dashboard/categories');
    } catch (error) {
      console.error(error);
      message.error("Erreur lors de l'ajout de la catégorie");
    }
  };

  // normalise la valeur Upload -> fileList
  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">
          <div className="col-md-12">
            <Breadcrumb
              separator={<RightOutlined style={{ fontSize: 16, color: '#999', fontWeight: 'bolder' }} />}
              style={{ marginBottom: 16 }}
            >
              <Breadcrumb.Item>
                <Link to="/dashboard" style={{ fontSize: 16, fontWeight: 'bolder' }}>🏠 ACCUEIL</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span style={{ fontSize: 16, fontWeight: 'bolder' }}>👥 AJOUT DE SERVICE</span>
              </Breadcrumb.Item>
            </Breadcrumb>

            <div className="card mb-4">
              <div className="card-body">
                <Form layout="vertical" form={form} onFinish={handleSubmit}>
                  {/* 1 ligne responsive : full width (xs) -> 2 colonnes (md+) */}
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="name"
                        label="Nom de la catégorie"
                        rules={[{ required: true, message: 'Veuillez entrer le libellé de la catégorie' }]}
                      >
                        <Input placeholder="Ex : Yango, Uber..." />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="image"
                        label="Image de la catégorie"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                        rules={[{ required: true, message: 'Veuillez sélectionner une image' }]}
                      >
                        <Upload beforeUpload={() => false} maxCount={1} listType="picture">
                          <Button icon={<UploadOutlined />}>Uploader une image</Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Actions : bouton plein largeur sur mobile, aligné à droite sur md+ */}
                  <Row>
                    <Col xs={24}>
                      <Form.Item style={{ marginBottom: 0, textAlign: screens.md ? 'right' : 'initial' }}>
                        <Button type="primary" htmlType="submit" block={!screens.md}>
                          Enregistrer
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AjoutCategorie;
